import RouterApp from "./RouterApp";

const App = () => {
  return <RouterApp />;
};

export default App;
